import React from "react";

export default function PartnershipsSection({ data, onPartner }) {
  return (
    <section className="institution-partnerships-section">
      <div className="container">
        <div className="row align-items-stretch institution-partnerships-section-main">
          <div className="col-lg-6">
            <div className="institution-partnerships-section-content">
              <span>{data.title}</span>
              <h2 className="heading">{data.heading}</h2>
              {data.paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
              <button type="button" className="default-btn" onClick={onPartner}>
                {data.button}
              </button>
            </div>
          </div>
          <div className="col-lg-6">
            <img
              src={data.image}
              alt={data.imageAlt}
              className="img-responsive institution-partnerships-section-image"
            />
          </div>
        </div>

      </div>
    </section>
  );
}
